<template>
  <div class="question">
    <form @submit.prevent="next">
      {{ from }}
      <h1>{{ parsedQuestion }}</h1>
      <p>{{ help }}</p>

      <div
        v-for="(input, dataKey) in model"
        class="input-container"
        :key="'input-' + dataKey"
      >
        <ButtonList
          v-if="input.type == 'button_list'"
          :options="input.options"
          :dataKey="dataKey"
          :value="userData[dataKey]"
          @input="
            saveInput(dataKey, $event);
            next();
          "
        />
        <DollarInput
          v-if="input.type == 'dollar'"
          :dataKey="dataKey"
          :default="input.default"
          :value="userData[dataKey]"
          @input="saveInput(dataKey, $event)"
          @next="next"
        />
        <TextInput
          v-if="input.type == 'text'"
          :dataKey="dataKey"
          :value="userData[dataKey]"
          :placeholder="input.placeholder"
          @input="saveInput(dataKey, $event)"
          :required="input.required"
          @next="next"
        />

        <NameInput
          v-if="input.type == 'name'"
          :dataKey="dataKey"
          @input="saveInput(dataKey, $event)"
          :required="input.required"
          @next="next"
        />

        <EmailInput
          v-if="input.type == 'email'"
          :dataKey="dataKey"
          @input="saveInput(dataKey, $event)"
          :required="input.required"
          @next="next"
        />

        <PhoneInput
          v-if="input.type == 'phone'"
          :dataKey="dataKey"
          @input="saveInput(dataKey, $event)"
          @next="next"
        />
        <YesNoInput
          v-if="input.type == 'yes_no'"
          :value="userData[dataKey]"
          @input="
            saveInput(dataKey, $event);
            next();
          "
        />

        <button
          class="bg-color-2 color-1"
          v-if="showNextButton && input.type != 'hidden'"
        >
          Next
        </button>
        <button
          class="bg-color-2 color-1"
          v-if="input.type == 'submit'"
          @click.prevent="submitForm"
        >
          Submit
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import ButtonList from '../components/questions/ButtonList'
import DollarInput from '../components/questions/DollarInput'
import NameInput from '../components/questions/NameInput'
import PhoneInput from '../components/questions/PhoneInput'
import TextInput from '../components/questions/TextInput'
import YesNoInput from '../components/questions/YesNoInput'
import EmailInput from '../components/questions/EmailInput'

export default {
  data () {
    return {
      from: null
    }
  },
  methods: {
    checkUserData () {
      if (this.userData == null) {
        this.$router.replace('/')
        this.$store.commit('initUserData')
        return false
      } else {
        return true
      }
    },
    evalutateConditions (conditions, currentPath) {
      if (conditions != null) {
        for (const condition of conditions) {
          if (!this.evalutateCondition(condition)) {
            this.next(true)
          }
        }
      }
    },
    evalutateCondition (condition) {
      const key = condition[0]
      const operator = condition[1]
      const value = condition[2]

      switch (operator) {
        case '=':
          return this.userData[key] === value
        case '!=':
          return this.userData[key] !== value
        case 'in':
          return value.includes(this.userData[key])
      }
    },
    goto (path, skip) {
      if (skip) {
        this.$router.replace(path)
      } else {
        this.$router.push(path)
      }
    },

    next (skip = false) {
      this.goto(this.nextQuestion.path, skip)
    },
    saveInput (key, event) {
      this.$store.commit('updateUserData', {
        key,
        value: event.value
      })
      if (event.nextRoutePath) {
        this.goto(event.nextRoutePath)
      }
    },
    setFrom (from) {
      this.from = from
    },
    submitForm () {
      this.$store.dispatch('submitForm').then((response) => {
        console.log('response', response)
        if (response != null) {
          alert(response)
        } else {
          this.next()
        }
      })
    }
  },
  computed: {
    userData () {
      return this.$store.state.userData
    },
    nextQuestion () {
      return this.$store.getters.nextQuestion
    },
    parsedQuestion () {
      let question = this.question
      const macros = {
        $first_name$: this.userData?.name?.first,
        $last_name$: this.userData?.name?.last
      }
      Object.keys(macros).forEach((key) => {
        question = question.replace(key, macros[key])
      })
      return question
    }
  },
  created () {
    this.$store.commit('setCurrentQuestion', this.path)
    if (this.checkUserData()) {
      this.evalutateConditions(this.conditions, this.path)
    }
    Object.keys(this.model).forEach((key) => {
      console.log(key)
      console.log(this.model[key])
      const value = this.model[key]
      if (value.type && value.type === 'hidden') {
        this.$store.commit('updateUserData', {
          key,
          value: value.value
        })
      }
    })
  },
  watch: {
    path (newValue) {
      this.$store.commit('setCurrentQuestion', this.path)
      this.evalutateConditions(this.conditions, newValue)
    },
    conditions (conditions) {
      // this.evalutateConditions(conditions)
    }
  },
  props: [
    'question',
    'model',
    'nextRoutePath',
    'path',
    'conditions',
    'help',
    'show-next-button'
  ],
  components: {
    ButtonList,
    TextInput,
    YesNoInput,
    DollarInput,
    NameInput,
    EmailInput,
    PhoneInput
  }
}
</script>
<style lang="scss">
.question {
  display: flex;
  flex-direction: column;

  h1,
  p {
    margin: 0;
  }
  h1 {
    font-size: 1.75em;
    margin-bottom: 0.5em;
  }
  p {
    font-size: 1.2em;
    margin-bottom: 2em;
  }
  form {
    display: flex;
    flex-direction: column;
    flex-grow: 1;

    .name-input {
      display: flex;
      flex-direction: column;
      align-items: center;

      label {
        margin-bottom: 0.5em;
      }
    }
  }

  // $color-1: white;
  // $color-2: #50b496;
  // $color-3: black;

  // .bg-color-1{
  //   background-color: $color-1;
  // }
  // .bg-color-2{
  //   background-color: $color-2;
  // }
  // .bg-color-3{
  //   background-color: $color-3;
  // }
  // .color-1{
  //   color: $color-1;
  //   border-color: $color-1;
  // }
  // .color-2{
  //   color: $color-2;
  //   border-color: $color-2;
  // }
  // .color-3{
  //   color: $color-3;
  //   border-color: $color-3;
  // }

  .button-container {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    flex-grow: 1;
  }

  button {
    font-size: 1.2em;
    padding: 1em 0.5em;
    margin: 0 0.5em;
    margin-bottom: 1em;
    border-radius: 3px;
    width: 100%;
    max-width: 300px;
    cursor: pointer;
    text-transform: capitalize;

    &:hover {
      opacity: 0.7;
    }

    &::before {
      content: "\f058";
      opacity: 0;
      font-family: "Font Awesome 5 Pro";
      font-weight: 900;
      font-size: 1.2em;
      margin-left: -2rem;
    }

    &.active::before {
      opacity: 1;
    }

    // Icons with button lists
    &.icon {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
      width: 25%;
      margin: 0;
      padding: 1em;

      &::before {
        display: none;
      }

      @media (max-width: 768px) {
        & {
          width: 50%;
        }
      }

      &:hover > span {
        opacity: 0.7;
      }

      > span {
        margin-bottom: 0.5em;
      }
    }

    // Button icons, and yes or no
    &.icon > span {
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      width: 110px;
      height: 110px;
      padding: 0;
      border-width: 1px;
      border-style: solid;
      border-radius: 50%;
      font-size: 2.4em;
      overflow: hidden;

      transition: color 300ms ease 150ms;
      transition: background-color 250ms ease;

      &:hover {
        opacity: 0.7;
      }

      &:focus {
        outline: none;
      }

      &::before {
        content: "";
        position: absolute;
        top: 50%;
        left: 50%;
        -webkit-transform: translate(-50%);
        transform: translate(-50%);
        width: 0px;
        height: 0px;
        transition: border-width 300ms ease, top 300ms ease;
        border: 0px solid transparent;
        border-radius: 100px;
        z-index: -1;
      }

      &.active {
        &::before {
          top: 0;
          border-width: 46px;
        }
      }
    }
  }

  input {
    font-size: 1.2em;
    padding: 0.75em 0.5em;
    border: 1px solid gray;
    border-radius: 3px;
    margin: 0 0.5em;
    margin-bottom: 1em;
    width: 100%;
    max-width: 300px;
    box-sizing: border-box;
  }
}

button {
  border: 0;
  border-width: 1px;
  border-style: solid;
  border-color: transparent;
  background-color: transparent;
}

input:last-child {
  margin-bottom: 5em;
}
</style>
